const styles = theme => ({
  containerWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    alignItems: 'start',
  },
  containerType: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    boxSizing: 'border-box',
    width: '100%',
  },
  wrapperLabelType: {
    width: '35px',
    height: 'auto',
    display: 'flex',
    overflow: 'hidden',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.gray[60],
    borderRadius: '8px 0 0 8px',
    border: `1px solid ${theme.palette.gray[20]}`,
    writingMode: 'vertical-rl',
    position: 'relative',
  },
  boxLabelType: {
    borderRadius: '8px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    width: '100%',
    height: '100%',
    position: 'absolute',
    transform: 'rotate(180deg)',
  },
  labelType: {
    fontWeight: 500,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    maxWidth: '100%',
    fontSize: '12px',
    lineHeight: '20px',
    padding: '6px',
    textAlign: 'center',
    color: theme.palette.common.white,
    cursor: 'default',
  },
  wrapperEmptyState: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.gray[5],
    padding: '8px 12px',
    borderRadius: '8px',
  },
  labelEmptyState: {
    fontSize: '12px',
    lineHeight: '130%',
    fontWeight: 400,
    color: theme.palette.gray[60],
  },
});

export default styles;
